import { render, staticRenderFns } from "./aiDashboard.vue?vue&type=template&id=55229178&scoped=true"
import script from "./aiDashboard.vue?vue&type=script&lang=js"
export * from "./aiDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55229178",
  null
  
)

export default component.exports